// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, func-names, default-param-last */
import type { Dispatch } from "redux"
import { Record } from "immutable"
import type { AuthToken } from "@kiwicom/nitro/lib/records/Auth"

import type { GetState } from "../../../types/state"
import cuckoo from "../../../services/cuckoo/cuckoo"
import { createEventLogUnified } from "@kiwicom/frontend-mmb/services/tracking/createEventLogUnified"

const SMART_FAQ_TOGGLE = "smartFAQ/SMART_FAQ_TOGGLE"

export type HelpArticle = {
  id: number
}

// See DOCs: https://gitlab.skypicker.com/frontend/smart-faq/blob/master/README.md#links-to-a-specific-article
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export const articles: {
  [key: string]: HelpArticle
} = {
  BLUE_RIBBON_BAGS_ARTICLE: {
    id: 179,
  },
  INCORRECT_TRAVEL_DETAILS: {
    id: 77,
  },
  TRAINS_ARTICLE: {
    id: 127,
  },
  PRIORITY_BOARDING_ARTICLE: {
    id: 168,
  },
  DISABLED_BAGS_IN_MMB_ARTICLE: {
    id: 253,
  },
  THROW_AWAY_TICKET_ARTICLE: {
    id: 135,
  },
  AIRLINE_GUARANTEE: {
    id: 134,
  },
  DISALLOWED_BAGS_ARTICLE: {
    id: 253,
  },
  RECHECK_BAGGAGE: {
    id: 250,
  },
  CANCEL_BOOKING: {
    id: 78,
  },
  CABIN_BAGGAGE: {
    id: 246,
  },
  PERSONAL_ITEM: {
    id: 246,
  },
  CHECKED_BAGGAGE: {
    id: 246,
  },
  USA_CUBA: {
    id: 123,
  },
  METASEARCH: {
    id: 139,
  },
  SELF_TRANSFER: {
    id: 68,
  },
  SELF_TRANSFER_LAYOVER: {
    id: 131,
  },
  RELEASE_NEWS: {
    id: 0, // not defined
  },
  REFUND_HOW_LONG: {
    id: 79,
  },
  PRIMERA_BANKRUPTCY: {
    id: 172,
  },
  AIR_HELP: {
    id: 169,
  },
  COBALT_BANKRUPTCY: {
    id: 175,
  },
  TRAVEL_INSURANCE: {
    id: 9,
  },
  SERVICE_PACKAGES: {
    id: 178,
  },
  PRIORITY_LINE: {
    id: 180,
  },
  WOWAIR_BANKRUPTCY: {
    id: 184,
  },
  JETAIR_BANKRUPTCY: {
    id: 188,
  },
  AIGLE_AZUR_BANKRUPTCY: {
    id: 198,
  },
  THOMAS_COOK_BANKRUPTCY: {
    id: 199,
  },
  PERUVIAN_BANKRUPTCY: {
    id: 203,
  },
  XL_BANKRUPTCY: {
    id: 204,
  },
  KIWI_COM_CREDIT: {
    id: 17,
  },
  AIRPORT_CHECKIN: {
    id: 319,
  },
  ONLINE_CHECKIN: {
    id: 108,
  },
  INVOICES_ARTICLE: {
    id: 121,
  },
  SPECIAL_ASSISTANCE: {
    id: 2,
  },
  MUSIC_AND_SPORT_EQUIPMENT: {
    id: 242,
  },
  PET_PASSENGERS: {
    id: 141,
  },
  REFUNDS_AND_CANCELLATIONS: {
    id: 155,
  },
  HOW_TO_CANCEL_FOR_REFUND: {
    id: 276,
  },
  BAGGAGE_BUNDLES: {
    id: 244,
  },
  BOOKING_CONFIRMATION: {
    id: 162,
  },
  FARE_TYPES: {
    id: 200,
  },
  LOYALTY_COMPASS: {
    id: 220,
  },
  WHAT_IS_GUARANTEE: {
    id: 28,
  },
  FORCE_MAJEURE: {
    id: 118,
  },
  LOYALTY_COMPASS_ABOUT: {
    id: 202,
  },
  CORONA_EMERGENCY: {
    id: 222,
  },
  TRAVELING_DURING_COVID: {
    id: 236,
  },
  VIRTUAL_BROKER: {
    id: 9999, // TODO add once known
  },
  CARRIER_RESTRICTIONS_CORONA: {
    id: 237,
  },
  PASSENGER_ATA_REFUND: {
    id: 89,
  },
  HIDDEN_CITIES: {
    id: 272,
  },
  CHANGE_TRIP: {
    id: 37,
  },
  VIRTUAL_CONTACT: {
    id: 300,
  },
  PROHIBITED_ITEMS: {
    id: 251,
  },
  CHECKIN_FEE_REFUND: {
    id: 285,
  },
  NO_CHECKED_BAG: {
    id: 253,
  },
  CHECK_IN_WITH_HIDDEN_CITY: {
    id: 309,
  },
  WHAT_IS_FLEXI_CHANGE: {
    id: 334,
  },
  WHAT_IS_FLEXI_CANCEL: {
    id: 335,
  },
  FLEXIBLE_TRIP: {
    id: 555,
  },
  DOCUMENT_VERIFICATION: {
    id: 459,
  },
  UNCONFIRMED_BOOKING_CANCELLATION: {
    id: 74,
  },
  BASIC_DISRUPTION_PROTECTION: {
    id: 509,
  },
  PREMIUM_DISRUPTION_PROTECTION: {
    id: 515,
  },
}

const Article = Record({
  id: null,
})

const DefaultWidgetState = Record({
  open: false,
  article: null,
})

const SmartFAQState = Record({
  widget: new DefaultWidgetState(),
})

export function toggleSmartFAQ(open: boolean, article?: HelpArticle | null) {
  return {
    type: SMART_FAQ_TOGGLE,
    open,
    article,
  }
}

export function handleSimpleToken(tokenInfo: AuthToken) {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (dispatch: Dispatch<any>, getState: GetState) => {
    const { bid, token } = tokenInfo
    const state = getState()
    const lang = state.options.get("language")

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    window.location.href = `/${lang}/manage/${bid}/${token}`
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toggleHelp = (open: boolean, article?: HelpArticle | null) => (dispatch: Dispatch<any>) => {
  dispatch(toggleSmartFAQ(open, article))
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const openHelp = (article?: HelpArticle | null) => (dispatch: Dispatch<any>) => {
  cuckoo.track(createEventLogUnified("sfaq", "learn more clicked"), {
    navigationSource: "mmb",
    ...(article?.id && {
      articleId: article.id,
    }),
  })
  dispatch(toggleHelp(true, article))
}

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function (state: Record<any> | null | undefined = new SmartFAQState(), action: any) {
  if (!(state instanceof SmartFAQState)) {
    return new SmartFAQState()
  }

  switch (action.type) {
    case SMART_FAQ_TOGGLE:
      return state.mergeIn(["widget"], {
        open: action.open,
        article: action.open && action.article ? new Article(action.article) : null,
      })
    default:
      return state
  }
}
